import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';

export class MenuConfig {

	constructor() { }



	public defaults: any = {

		aside: {
			self: {},
			items: [
			
				
				//{section: 'Applications'},
				
				{
					title: 'User Management',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-user-outline-symbol',
					submenu: [
						{
							title: 'Users',
							page: '/user-management/users'
						},
						{
							title: 'Roles',
							page: '/user-management/roles'
						}
					]
				},

			//	{section: 'Applications'},
				
				{
					title: 'User Management',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-user-outline-symbol',
					submenu: [
						{
							title: 'Users',
							page: '/user-management/users'
						},
						{
							title: 'Roles',
							page: '/user-management/roles'
						}
					]
				},
				
			
			]
		},
	};

	public get configs(): any {

		 ;

	var returnitm= [
			
				
		//{section: 'Applications'},
		
		{
			title: 'testt',
			root: true,
			bullet: 'dot',
			icon: 'flaticon2-user-outline-symbol',
			submenu: [
				{
					title: 'Users',
					page: '/user-management/users'
				},
				{
					title: 'Roles',
					page: '/user-management/roles'
				}
			]
		},

	//	{section: 'Applications'},
		
		{
			title: 'test-1;',
			root: true,
			bullet: 'dot',
			icon: 'flaticon2-user-outline-symbol',
			submenu: [
				{
					title: 'Users',
					page: '/user-management/users'
				},
				{
					title: 'Roles',
					page: '/user-management/roles'
				}
			]
		},
		
	
	];

	// this.http.get<any>(this.baseUrl+'GetMenu').subscribe(data=>{

	// 	 ;
	// 	returnitm=data;
	// })

	 ;

	this.defaults.aside.items=returnitm;

		return this.defaults;
	}
}
